function initializeTheme() {
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.hdr-nav');
  if (toggle && nav && !toggle.dataset.initialized) { toggle.dataset.initialized = 'true'; toggle.addEventListener('click', function () {
    var open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  }
  var top = document.getElementById('BackToTop');
  if (top && !top.dataset.initialized) {
    top.dataset.initialized = 'true';
    window.addEventListener('scroll', function () {
      top.classList.toggle('show', window.scrollY > 600);
    }, { passive: true });
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  // Rotating announcement bar
  var strip = document.querySelector('.topstrip.multi');
  if (strip && !strip.dataset.initialized) {
    strip.dataset.initialized = 'true';
    var items = strip.querySelectorAll('.topstrip-item');
    if (items.length > 1) {
      var i = 0;
      var timer = setInterval(function () {
        if (!strip.isConnected) { clearInterval(timer); return; }
        items[i].classList.remove('on');
        i = (i + 1) % items.length;
        items[i].classList.add('on');
      }, 4000);
    }
  }
}
document.addEventListener('DOMContentLoaded', initializeTheme);
document.addEventListener('shopify:section:load', initializeTheme);
document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-variant-select]')) return;
  var url = new URL(window.location.href);
  url.searchParams.set('variant', event.target.value);
  window.location.assign(url.href);
});
